import type { HTMLAttributes } from 'react'
import { cn } from '~/lib/utils'

export type CardProps = HTMLAttributes<HTMLDivElement>

/** 콘텐츠 표면 컨테이너. KRDS: 또렷한 보더 + 아주 옅은 elevation. */
export function Card({ className, ...props }: CardProps) {
    return (
        <div
            data-slot='card'
            className={cn(
                'border-border bg-card text-card-foreground rounded-[var(--radius)] border',
                className
            )}
            {...props}
        />
    )
}

export function CardHeader({ className, ...props }: CardProps) {
    return (
        <div
            className={cn('admin-panel-head flex flex-col gap-1', className)}
            {...props}
        />
    )
}

export function CardTitle({
    className,
    ...props
}: HTMLAttributes<HTMLHeadingElement>) {
    return (
        <h3
            className={cn('krds-title text-foreground', className)}
            {...props}
        />
    )
}

export function CardDescription({
    className,
    ...props
}: HTMLAttributes<HTMLParagraphElement>) {
    return (
        <p
            className={cn('text-muted-foreground text-sm', className)}
            {...props}
        />
    )
}

export function CardContent({ className, ...props }: CardProps) {
    return <div className={cn('p-5', className)} {...props} />
}

export function CardFooter({ className, ...props }: CardProps) {
    return (
        <div
            className={cn('flex items-center gap-2 p-5 pt-0', className)}
            {...props}
        />
    )
}
